import { useEffect, useState, useRef } from "react";
import "../styles/Home.css";
import CardCarousel from "../components/CardCarousel";
// import SearchBar from "../components/SearchBar";
import Playlist from "./Playlist";
import cals from '../assets/icons/0 Calories.svg';
import Modal from "react-modal";
import MusicRecommendation from "../custom/MusicRecommendation";
import BookRecommendation from "../custom/BookRecommendation";
import MenuDrops from "../custom/MenuDrops";
import database from "../config/FirbaseConfig";


const GAMES = [
    {
        label: "Color",
        href: "/Game/Color",
        icon: (
            <path d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-84 32-157t87.5-127q55.5-54 130-85T489-880q79 0 150 26.5T763.5-780q53.5 47 85 111.5T880-527q0 108-63 170.5T650-294h-75q-18 0-31 14t-13 31q0 20 14.5 38t14.5 43q0 26-24.5 57T480-80ZM282-469q15-15 15-35t-15-35q-15-15-35-15t-35 15q-15 15-15 35t15 35q15 15 35 15t35-15Zm126-170q15-15 15-35t-15-35q-15-15-35-15t-35 15q-15 15-15 35t15 35q15 15 35 15t35-15Zm214 0q15-15 15-35t-15-35q-15-15-35-15t-35 15q-15 15-15 35t15 35q15 15 35 15t35-15Zm131 170q15-15 15-35t-15-35q-15-15-35-15t-35 15q-15 15-15 35t15 35q15 15 35 15t35-15Z" />
        ),
    },
    {
        label: "Time",
        href: "/Game/Time",
        icon: (
            <path d="M360-860v-60h240v60H360Zm90 447h60v-230h-60v230ZM340.5-109.5Q275-138 226-187t-77.5-114.5Q120-367 120-441t28.5-139.5Q177-646 226-695t114.5-77.5Q406-801 480-801q67 0 125.5 22T710-717l51-51 43 43-51 51q36 40 61.5 97T840-441q0 74-28.5 139.5T734-187q-49 49-114.5 77.5T480-81q-74 0-139.5-28.5Z" />
        ),
    },
    {
        label: "Sound",
        href: "/Game/Sound",
        icon: (
            <path d="M709-255H482L369-142q-23 23-56.5 23T256-142L143-255q-23-23-23-57t23-57l112-112v-227l454 453ZM289-785q107-68 231.5-54.5T735-736q90 90 103.5 214.5T784-290l-58-58q45-82 31.5-173.5T678-679q-66-66-157.5-79.5T347-727l-58-58Zm118 118q57-17 115-7t100 52q42 42 51.5 99.5T666-408l-68-68q0-25-7.5-48.5T566-565q-18-18-41.5-26t-49.5-8l-68-68Z" />
        ),
    },
    {
        label: "Shape",
        href: "/Game/Shape",
        icon: (
            <path d="M240-520q-83 0-141.5-58.5T40-720q0-84 58.5-142T240-920q84 0 142 58t58 142q0 83-58 141.5T240-520ZM620-40q-25 0-42.5-17.5T560-100v-240q0-25 17.5-42.5T620-400h240q25 0 42.5 17.5T920-340v240q0 25-17.5 42.5T860-40H620Zm95-632L288-246q7 12 10.5 25.5T302-192q0 45-32 77.5T192-82q-45 0-77.5-32.5T82-192q0-46 32.5-78t77.5-32q15 0 28.5 3.5T246-288l426-427q-7-12-10.5-25.5T658-768q0-46 32.5-78t77.5-32q46 0 78 32t32 78q0 45-32 77.5T768-658q-14 0-27.5-3.5T715-672Z" />
        ),
    },
    {
        label: "Puzzle",
        href: "/Game/Puzzle",
        icon: (
            <path d="M120-241q0-12.21 8.11-20.61 8.12-8.39 19.71-8.39 6.18 0 11.18 2.5t10 5.5q12 8 26 12.5t29 4.5q45 0 75.5-30.5T330-351q0-45-30.5-75.5T224-457q-14.65 0-28.33 4.5Q182-448 169-440q-5 3-10 5.5t-11.18 2.5q-11.59 0-19.71-8.39Q120-448.79 120-461v-131q0-14 10.5-24.5T155-627h184q-13-20-18.5-42.67Q315-692.33 315-715q0-68.75 48.18-116.88 48.17-48.12 117-48.12Q549-880 597-831.88q48 48.13 48 116.88 0 22.67-5.5 45.33Q634-647 621-627h184q14 0 24.5 10.5T840-592v131q0 12.33-8.15 20.66-8.14 8.34-20.18 8.34-5.67 0-10.67-2.33-5-2.34-10-5.67-12-8-26-12.5t-29-4.5q-45 0-75.5 30.5T630-351q0 45 30.5 75.5T736-245q15 0 29-4.5t26-12.5q5-3 9.95-5.5Q805.9-270 812-270q11.9 0 19.95 8.34Q840-253.32 840-241v125.92q0 14.08-10.5 24.58Q819-80 805-80H155q-14 0-24.5-10.5T120-115.08V-241Z" />
        ),
    },
];

// How long the press animation gets to play before we actually navigate.
const NAV_DELAY_MS = 140;

const QUESTION_BANK = {
    "Operations": [
        { q: "Takeaway packaging ideas for Pides, Burgers, Pastas and other items?", type: "text" },
        { q: "Any scope of improvement in our cutlery? We currently use takeaway cutlery in outdoor sections too.", type: "text" },
        { q: "Sustainability initiatives you think we should be a part of?", type: "text" },
    ],
    "Service": [
        { q: "How would you solve the valet problem in Bandra whilst respecting our neighbours?", type: "text" },
        { q: "Larger menus or limited menus — what do you prefer and why?", type: "text" },
        { q: "Should we do a 12-seater omakase experience for coffee and bread pairings? If yes, what should it be priced at?", type: "text" },
    ],
    "Production": [
        { q: "Any flavoured syrups we should try / experiment with?", type: "text" },
        { q: "Any South Indian dish that you'd recommend us to draw inspiration from?", type: "text" },
        { q: "Collabs we should consider for farm to table concept.", type: "text" },
        { q: "What ingredients should we experiment with?", type: "text" },
    ],
    "Social Media": [
        { q: "Write a short elevator pitch for 'Businesses at Ettarra' — all about the business you'd like people to know.", type: "text" },
        { q: "Any random ideas, references or reel links we can implement and work on?", type: "text" },
        { q: "Write a short piece for 'Couples of Ettarra' — Humans of Ettarra style feature.", type: "text" },
    ],
    "Generic": [
        { q: "Should we consider doing outdoor catering? If yes, any leads or connections we should follow up with?", type: "text" },
        { q: "Books you'd recommend (with authors) for our team or patrons to read.", type: "text" },
        { q: "Non-FnB brands that remind you of Ettarra — feels rooted and Indian?", type: "text" },
    ],
};

const FeedbackCards =
{
    "Layout": [
        {
            "BackgroundColor": "#FFFFFF",
            "BackgroundImage": "https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/icons%2F1.png?alt=media&token=b8b5be1d-6999-464d-8cf0-59f96a1d1c1a",
            "Card": 1,
            "ImageBrightnessFilter": 1,
            "Link": "",
            "TextColor": "#AFA39B",
            "Title": "Operations",
            "Verification": ""
        },
        {
            "BackgroundColor": "#FFFFFF",
            "BackgroundImage": "https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/icons%2F7.png?alt=media&token=dd5a037b-529f-4e49-8608-beab5638122f",
            "Card": 2,
            "ImageBrightnessFilter": 1,
            "Link": "",
            "TextColor": "#AFA39B",
            "Title": "Service",
            "Verification": ""
        },
        {
            "BackgroundColor": "#FFFFFF",
            "BackgroundImage": "https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/icons%2F4.png?alt=media&token=fa25eb30-52e7-4bfb-a1a6-9597c8f11848",
            "Card": 3,
            "ImageBrightnessFilter": 1,
            "Link": "",
            "TextColor": "#AFA39B",
            "Title": "Production",
            "Verification": ""
        },
        {
            "BackgroundColor": "#FFFFFF",
            "BackgroundImage": "https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/icons%2F3.png?alt=media&token=ba9cd050-ad9c-4e30-8813-0851d264dc25",
            "Card": 4,
            "ImageBrightnessFilter": 1,
            "Link": "",
            "TextColor": "#AFA39B",
            "Title": "Social Media",
            "Verification": ""
        },
        {
            "BackgroundColor": "#FFFFFF",
            "BackgroundImage": "https://firebasestorage.googleapis.com/v0/b/samudaya-ettarra.firebasestorage.app/o/icons%2F6.png?alt=media&token=3ab540cb-74b8-41fa-b838-752a38dc10ff",
            "Card": 5,
            "ImageBrightnessFilter": 1,
            "Link": "",
            "TextColor": "#AFA39B",
            "Title": "Generic",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        },
        {
            "BackgroundColor": "",
            "BackgroundImage": "",
            "Card": "",
            "ImageBrightnessFilter": "",
            "Link": "",
            "TextColor": "",
            "Title": "",
            "Verification": ""
        }
    ],
    "Position": 4,
    "Status": "Enable",
    "Type": "Card Grid"

}

const Home = ({ restaurantID, Layout, Labels, menuObj, DietaryFilters, Dietary, setDietary, LandingPage, cart, setCart, RestaurantDetails, AddOns, Ordering, Messages, NavigationSuggestions }) => {
    const [Data, setData] = useState(null);
    const [ListCardSliderExpanded, setListCardSliderExpanded] = useState(false);
    const [isStickyBanner, setIsStickyBanner] = useState(false);
    const [modalFilter, setModalFilter] = useState(null);
    const bannerRef = useRef(null);
    const triggerRef = useRef(null);
    const [activeDomain, setActiveDomain] = useState(null);
    const [answers, setAnswers] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const getUser = () =>
        JSON.parse(localStorage.getItem(`${restaurantID}_s9userinfo`) || "{}");

    const getSearchParams = () =>
        JSON.parse(localStorage.getItem(`${restaurantID}_searchParams`) || "{}");

    const getFeedbackKey = (domain) => {
        const user = getUser();
        return `${restaurantID}_feedback_${domain}_${user?.phone}`;
    };

    const openFeedbackModal = (domain) => {
        setActiveDomain(domain);

        const saved = localStorage.getItem(getFeedbackKey(domain));

        if (saved) {
            const parsed = JSON.parse(saved);

            // ✅ FORCE ARRAY
            if (Array.isArray(parsed)) {
                setAnswers(parsed);
            } else {
                setAnswers(Object.values(parsed)); // convert object → array
            }
        } else {
            setAnswers([]);
        }

        setShowModal(true);
    };


    const normalizeAnswers = (data) => {
        if (!data) return [];
        if (Array.isArray(data)) return data;
        return Object.values(data);
    };

    const handleTextChange = (index, value) => {
        const current = normalizeAnswers(answers);

        const updated = [...current];

        updated[index] = {
            question: QUESTION_BANK[activeDomain][index].q,
            answer: value,
            image: updated[index]?.image || "",
        };

        setAnswers(updated);

        localStorage.setItem(
            getFeedbackKey(activeDomain),
            JSON.stringify(updated)
        );
    };

    const handleImageChange = (index, file) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            const base64 = reader.result;

            const current = normalizeAnswers(answers);
            const updated = [...current];

            updated[index] = {
                question: QUESTION_BANK[activeDomain][index].q,
                answer: updated[index]?.answer || "",
                image: base64,
            };

            setAnswers(updated);

            localStorage.setItem(
                getFeedbackKey(activeDomain),
                JSON.stringify(updated)
            );
        };

        reader.readAsDataURL(file);
    };

    const handleSubmit = () => {
        const user = getUser();

        if (!user?.name || !user?.phone) {
            const name = window.prompt("Please enter your name:");
            if (!name || name.trim().length < 2) {
                alert("Name must be at least 2 characters.");
                return;
            }
            const phone = window.prompt("Please enter your 10-digit phone number:");
            const phoneRegex = /^[6-9]\d{9}$/;
            if (!phoneRegex.test(phone)) {
                alert("Invalid phone number format.");
                return;
            }

            localStorage.setItem(
                `${restaurantID}_s9userinfo`,
                JSON.stringify({ name: name.trim(), phone })
            );
            return;
        }

        const current = normalizeAnswers(answers);

        // ✅ at least one answer
        const hasAtLeastOneAnswer = current.some(
            (ans) =>
                (ans?.answer && ans.answer.trim() !== "") ||
                (ans?.image && ans.image !== "")
        );

        if (!hasAtLeastOneAnswer) {
            alert("Please answer at least one question.");
            return;
        }

        // ✅ CLEAN answers (no empty junk)
        const cleanedAnswers = current
            .map((ans, i) => ({
                question: QUESTION_BANK[activeDomain][i].q,
                answer: ans?.answer || "",
                image: ans?.image || ""
            }))
            .filter(
                (ans) =>
                    (ans.answer && ans.answer.trim() !== "") ||
                    (ans.image && ans.image !== "")
            );

        const unix = Date.now();

        const tableId = localStorage.getItem(`${restaurantID}_S9Table`) || "";

        const feedback = {
            name: user.name,
            phone: user.phone,
            domain: activeDomain,
            answers: cleanedAnswers,
            timestamp: new Date().toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false }).replace("T", " "),
            unix: unix,
            table: tableId,
            ...getSearchParams(),
        };

        const path = `s9domainfeedback/${restaurantID}/${user.phone}/${activeDomain}`;

        // ✅ MERGE (important)
        database.ref(path).update(feedback);

        // ✅ ALSO update localStorage with cleaned version
        localStorage.setItem(
            getFeedbackKey(activeDomain),
            JSON.stringify(current)
        );

        alert("Feedback submitted!");
    };

    const CustomLayoutEmbed = ({ layoutData }) => {
        const containerRef = useRef(null);

        useEffect(() => {
            // 1. Create the Bridge function
            window.handleCustomLayoutClick = (link) => {
                if (redirectTrigger) {
                    redirectTrigger(`${link}`);
                } else {
                    console.error("redirectTrigger is missing in CustomLayoutEmbed");
                }
            };

            // Cleanup
            return () => {
                // Safety: Only delete if it's still our function to avoid conflicts with other components
                if (window.handleCustomLayoutClick) {
                    delete window.handleCustomLayoutClick;
                }
            };
        }, []);

        useEffect(() => {
            if (!containerRef.current || !layoutData) return;

            const { HTML, CSS, JavaScript } = layoutData;
            // Inject HTML & CSS
            const rawHtml = `
                <style>${CSS || ''}</style>
                ${HTML || ''}
            `;
            containerRef.current.innerHTML = rawHtml;

            // Inject JS safely
            if (JavaScript) {
                const script = document.createElement("script");
                script.textContent = JavaScript;
                containerRef.current.appendChild(script);
            }

        }, [layoutData]);

        return <div ref={containerRef} />;
    };

    const [abModal, setAbModal] = useState(false);

    const [abFeedback, setAbFeedback] = useState(() => {
        return JSON.parse(localStorage.getItem(`${restaurantID}_abFeedback`) || "{}");
    });

    const user = JSON.parse(localStorage.getItem(`${restaurantID}_s9userinfo`) || "{}");
    const searchData = JSON.parse(localStorage.getItem(`${restaurantID}_searchParams`) || "{}");

    const userKey = `${(user?.phone)?.replace(/\D/g, "")}`;

    const updateABFeedback = (data) => {
        const updated = {
            ...abFeedback,
            ...data,
            name: user?.name || "",
            phone: user?.phone || "",
            searchParams: searchData,
            updatedAt: new Date().toISOString(),
            unix: Date.now()
        };

        setAbFeedback(updated);
        localStorage.setItem(`${restaurantID}_abFeedback`, JSON.stringify(updated));
    };

    const submitABFeedback = async () => {
        const requiredFields = [
            "homeLayout",
            "categoryCards",
            "helpCards",
            "itemListLayout"
        ];

        const isValid = requiredFields.every(field => abFeedback?.[field]);

        if (!isValid) {
            alert("Please answer all questions.");
            return;
        }

        const finalPayload = {
            ...abFeedback,
            restaurantID,
            timestamp: new Date()
                .toLocaleString("sv-SE", { timeZone: "Asia/Kolkata", hour12: false })
                .replace("T", " "),
            unix: Date.now()
        };

        try {
            if (!userKey) {
                const name = window.prompt("Please enter your name:");
                if (!name || name.trim().length < 2) {
                    alert("Name must be at least 2 characters.");
                    return;
                }
                const phone = window.prompt("Please enter your 10-digit phone number:");
                const phoneRegex = /^[6-9]\d{9}$/;
                if (!phoneRegex.test(phone)) {
                    alert("Invalid phone number format.");
                    return;
                }

                localStorage.setItem(
                    `${restaurantID}_s9userinfo`,
                    JSON.stringify({ name: name.trim(), phone })
                );
                return;
            }

            await database
                .ref(`s9abFeedback/${restaurantID}/${userKey}`)
                .update(finalPayload);

            window.gtag("event", "AB_Feedback_Submitted", {
                feedback: finalPayload,
                ...searchData
            });

            alert("Thanks for your feedback!");
            setAbModal(false);

        } catch (err) {
            console.error(err);
            alert("Error saving feedback");
        }
    };

    const redirectTrigger = (e) => {
        const timestamp = new Date();
        // Track successful login event
        window.gtag("event", `${restaurantID}_${e}_Click`, { 'timestamp': timestamp.toLocaleString(), "restaurant": restaurantID, "click": e });
        window.location.href = e
    };

    const groupByNameWithVariants = (items) => {
        const grouped = {};

        items?.forEach(item => {
            const name = item.Name;
            const variant = String(item?.Variation).replace(item?.Name || "", "").replace(/\(|\)/g, "").trim();
            if (!grouped[name]) {
                grouped[name] = {
                    ...item,
                    Price: {}
                };
            }
            if (item.Price !== 0) {
                grouped[name].Price[`${variant ? variant : item?.Variation}`] = item.Price;
            }
        });

        return Object.values(grouped).sort((a, b) => a.Rank - b.Rank);
    };

    useEffect(() => {
        try {
            const getData = async () => {
                const groupedData = groupByNameWithVariants(menuObj);
                setData(groupedData);
            };
            getData();
        }

        catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
        }

    }, [menuObj]);

    // Detect when the search bar becomes sticky
    useEffect(() => {
        const handleScroll = () => {
            if (!bannerRef.current) return;
            const top = window.scrollY;
            if (top <= 1 && isStickyBanner) {
                setIsStickyBanner(false);
                console.log("Banner is not sticky");
            }
            if (top > 1 && !isStickyBanner) {
                setIsStickyBanner(true);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isStickyBanner]);

    const handleFilterClick = (filterObj) => {
        const key = filterObj.filter;

        // If something is already selected → unselect directly
        if (Dietary[key]) {
            const newState = { ...Dietary };
            delete newState[key];
            setDietary(newState);
            return;
        }

        // If only 1 option → auto-select it
        if (filterObj.subOptions.length === 1) {
            setDietary({
                ...Dietary,
                [key]: filterObj.subOptions[0]
            });
            return;
        }

        setModalFilter(filterObj);
    };

    const [pressedIndex, setPressedIndex] = useState(null);

    const handleActivate = (href, idx) => {
        setPressedIndex(idx);
        setTimeout(() => {
            window.location.href = href;
        }, NAV_DELAY_MS);
    };


    return (
        <div className="HomeContainer">
            <div className="Home">
                {Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Type'] === "Landing Banner" &&
                    <div ref={bannerRef} className={`HomeLandingBanner ${Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Size'] === 'H:W 1:1' ? "HomeLandingBannerFull" : ""}  ${Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Size'] === 'H:W 1:2' ? "HomeLandingBannerHalf" : ""} ${Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Size'] === 'H:W 2:3' ? "HomeLandingBannerTwoThird" : ""} ${isStickyBanner ? "stickyBanner" : ""}`} onClick={() => redirectTrigger(`${Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Link']}`)}>
                        {Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Image'] &&
                            <img src={Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Image']} alt="HomeLandingBanner" />
                        }
                    </div>
                }
                {Layout?.[Layout?.findIndex(item => item.Type === "Logo")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "Logo")]?.['Type'] === "Logo" &&
                    <div className={`HomePageLogo`} style={Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Type'] === "Landing Banner" ? null : { position: 'relative', height: '110px' }}>
                        {Layout?.[Layout?.findIndex(item => item.Type === "Logo")]?.['Image'] &&
                            <img style={Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "Landing Banner")]?.['Type'] === "Landing Banner" ? null : { height: '80px' }} src={Layout?.[Layout?.findIndex(item => item.Type === "Logo")]?.['Image']} alt="HomeLandingBanner" />
                        }
                    </div>
                }

                {/* {Layout?.[Layout?.findIndex(item => item.Type === "SearchBar")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "SearchBar")]?.['Type'] === "Search Bar" && <SearchBar restaurantID={restaurantID} menuObj={menuObj} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} />} */}

                {Layout && Layout.sort((a, b) => (a?.['Position'] ?? 0) - (b?.['Position'] ?? 0)).map((item, index) => {
                    return (
                        item?.['Status'] === "Enable" &&
                        <div key={index} id={(`${item['Type']}_${item?.['Type']}_${item?.['Position']}_${index}`).replace(/\s/g, "_").replace("__", "_")}>
                            {item && item?.['Status'] === "Enable" && item?.['Type'] &&
                                <div key={index} style={{ width: '100%' }}>
                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Section Break Line" &&
                                        <div className="header-container">
                                            <div className="line-with-heading" style={{ backgroundColor: item?.['LineColor'] }}>
                                                <span className="container-heading" style={{ color: item?.['TextColor'] }}>{item?.['Text']}</span>
                                            </div>
                                        </div>
                                    }
                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Peferences Filter" && DietaryFilters && typeof DietaryFilters === "object" && Object.keys(DietaryFilters).length > 0 &&
                                        <div className="DietaryPrefRow">
                                            <i>Dietary&nbsp;Preferences&nbsp;&nbsp;</i>
                                            {DietaryFilters && DietaryFilters !== null && Object.keys(DietaryFilters).map((filterName) => {

                                                const filterObj = DietaryFilters?.[filterName];
                                                const isSelected = !!Dietary?.[filterName];

                                                return (
                                                    <div
                                                        key={filterName}
                                                        ref={triggerRef}
                                                        className={isSelected ? "DietaryPrefSelected" : "DietaryPref"}
                                                        onClick={() => handleFilterClick(filterObj)}
                                                    >
                                                        {filterName}
                                                    </div>
                                                );
                                            })}
                                            {modalFilter && (
                                                <Modal
                                                    isOpen={true}
                                                    onRequestClose={() => setModalFilter(null)}
                                                    style={{
                                                        overlay: {
                                                            backgroundColor: "rgba(0,0,0,0.4)",
                                                            zIndex: 9999,
                                                        },
                                                        content: {
                                                            position: "absolute",
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: "translate(-50%, -50%)",
                                                            padding: "20px",
                                                            width: "fit-content",
                                                            height: "fit-content",
                                                            borderRadius: "25px",
                                                            border: "1px solid #ccc",
                                                            backgroundColor: "#FFFFFFF0",
                                                            backdropFilter: "blur(10px)",
                                                        },
                                                    }}
                                                >
                                                    <div><strong>&nbsp;Select Preference</strong></div>
                                                    <div style={{ fontSize: '12px', lineHeight: '12px', margin: "0px 5px 15px 5px", color: '#001E3A' }}><i>Please notify our team at the time of ordering</i></div>
                                                    {modalFilter.subOptions.map((opt) => (
                                                        <div
                                                            key={opt}
                                                            style={{
                                                                width: "265px",
                                                                padding: "12px 15px",
                                                                marginTop: "7px",
                                                                borderRadius: "25px",
                                                                background: Dietary[modalFilter.filter] === opt ? "#001E3A" : "#EFEFEF",
                                                                color: Dietary[modalFilter.filter] === opt ? "#FFFFFF" : "#001E3A",
                                                                cursor: "pointer",
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}
                                                            onClick={() => {
                                                                setDietary((prev) => {
                                                                    const newDiet = { ...prev };

                                                                    if (newDiet[modalFilter.filter] === opt) {
                                                                        // If clicking the same option again → clear it
                                                                        delete newDiet[modalFilter.filter];
                                                                    } else {
                                                                        // Otherwise set it
                                                                        newDiet[modalFilter.filter] = opt;
                                                                    }

                                                                    return newDiet;
                                                                });

                                                                setModalFilter(null);
                                                            }}

                                                        >
                                                            <div
                                                                style={{
                                                                    width: "16px",
                                                                    height: "16px",
                                                                    borderRadius: "16px",
                                                                    border: Dietary[modalFilter.filter] === opt ? "3px solid white" : "1px solid #001E3A",
                                                                    background: Dietary[modalFilter.filter] === opt ? "#001E3A" : "transparent",
                                                                    boxSizing: "border-box",
                                                                }}
                                                            />&nbsp;{opt}
                                                        </div>
                                                    ))}
                                                </Modal>
                                            )}
                                        </div>
                                    }
                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Banner" &&
                                        <div className="BannerContainer">
                                            {GAMES.map((game, idx) => (
                                                <button
                                                    key={game.href}
                                                    type="button"
                                                    className={`GameCard${pressedIndex === idx ? " is-pressed" : ""}`}
                                                    style={{ "--i": idx }}
                                                    onClick={() => handleActivate(game.href, idx)}
                                                >
                                                    <svg
                                                        className="GameCard__icon"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        height="125px"
                                                        viewBox="0 -960 960 960"
                                                        width="100px"
                                                        fill="#FFF4E6"
                                                    >
                                                        {game.icon}
                                                    </svg>
                                                    <span className="GameCard__label">{game.label}</span>
                                                </button>
                                            ))}
                                        </div>
                                        // <div className={`BannerContainer`}>
                                        //     {item?.Layout?.sort((a, b) => (a?.Card ?? 0) - (b?.Card ?? 0)).map((bannerItem, bannerIndex) => {

                                        //         if (!bannerItem['Card']) return null;
                                        //         const key = bannerItem?.Link;

                                        //         let hasItems = (menuObj && (menuObj?.some(menuItem => (menuItem?.[key.split('/')[1]] === key.split('/')[key.split('/').length - 1] || menuItem?.[key?.split('/')[0]]?.includes(key?.split('/')[key?.split('/').length - 1])) && menuItem?.Price > 0 && menuItem?.Visible === true && menuItem?.Available === true)));

                                        //         let availableItemCount = (menuObj ?? []).filter(menuItem =>
                                        //             (menuItem?.[key.split('/')[1]] === key.split('/').at(-1) ||
                                        //                 menuItem?.[key.split('/')[1]]?.includes?.(key.split('/').at(-1))) &&
                                        //             menuItem?.Visible === true &&
                                        //             menuItem?.Available === true &&
                                        //             menuItem?.Price > 0).length;

                                        //         if (!bannerItem['Verification'] || bannerItem['Verification'] !== 'Check' || bannerItem['Verification'] === "Don't Check") {
                                        //             hasItems = true;
                                        //             availableItemCount = null;
                                        //         }

                                        //         return (
                                        //             <div
                                        //                 key={bannerIndex}
                                        //                 disabled={!hasItems}
                                        //                 onClick={() => hasItems ? (bannerItem['Link'] && redirectTrigger(`${bannerItem['Link']}`)) : null}
                                        //                 className={`Banner`}
                                        //                 style={{ backgroundColor: bannerItem['BackgroundColor'], filter: hasItems ? 'none' : 'grayscale(100%) brightness(75%)', cursor: hasItems ? 'pointer' : 'none' }}
                                        //             >
                                        //                 {!hasItems && <div style={{ position: 'absolute', top: '7px', left: '15px', color: '#FFFFFF', fontSize: '8px', lineHeight: '9px', fontWeight: '500', width: '15vw', zIndex: 30, textShadow: '0px 0px 10px #000000' }}>
                                        //                     {Dietary && Object.keys(Dietary).filter(pref => Dietary[pref]).join(', ')} Item(s) Unavailable</div>}
                                        //                 {bannerItem['BackgroundImage'] &&
                                        //                     <>
                                        //                         <img
                                        //                             src={bannerItem['BackgroundImage']}
                                        //                             alt="BannerImage"
                                        //                             style={{ filter: `brightness(${bannerItem['ImageBrightnessFilter']})`, zIndex: 1 }}
                                        //                         />
                                        //                         <img
                                        //                             src={bannerItem['BackgroundImage']}
                                        //                             alt="BannerImage"
                                        //                         />
                                        //                     </>}
                                        //                 <span className="BannerText" style={{ color: bannerItem['TextColor'], zIndex: 3, textShadow: `1px 1px 5px #001E3A25` }}>
                                        //                     {availableItemCount ?
                                        //                         <>
                                        //                             <span style={{ position: 'relative', top: '0px', left: '0px', color: '#FFFFFF', fontSize: '9px', lineHeight: '7px', fontWeight: '500', width: '15vw', textShadow: '0px 0px 10px #000000' }}>
                                        //                                 <i>{availableItemCount} {availableItemCount === 1 ? 'Item' : 'Items'}</i>
                                        //                             </span>
                                        //                             <br />
                                        //                         </> : <></>
                                        //                     }
                                        //                     {bannerItem['Title']}
                                        //                 </span>
                                        //             </div>
                                        //         )
                                        //     }
                                        //     )}
                                        // </div>
                                    }
                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Card Grid" &&
                                        <div className={`CardGridContainer`}>
                                            {FeedbackCards?.Layout?.sort((a, b) => (a?.Card ?? 0) - (b?.Card ?? 0)).map((bannerItem, bannerIndex) => {

                                                if (!bannerItem['Card']) return null;
                                                const key = bannerItem?.Link;

                                                let hasItems = (menuObj && (menuObj?.some(menuItem => (menuItem?.[key.split('/')[1]] === key.split('/')[key.split('/').length - 1] || menuItem?.[key?.split('/')[0]]?.includes(key?.split('/')[key?.split('/').length - 1])) && menuItem?.Price > 0 && menuItem?.Visible === true && menuItem?.Available === true)));

                                                let availableItemCount = (menuObj ?? []).filter(menuItem =>
                                                    (menuItem?.[key.split('/')[1]] === key.split('/').at(-1) ||
                                                        menuItem?.[key.split('/')[1]]?.includes?.(key.split('/').at(-1))) &&
                                                    menuItem?.Visible === true &&
                                                    menuItem?.Available === true &&
                                                    menuItem?.Price > 0).length;

                                                if (!bannerItem['Verification'] || bannerItem['Verification'] !== 'Check' || bannerItem['Verification'] === "Don't Check") {
                                                    hasItems = true;
                                                    availableItemCount = null;
                                                }

                                                return (<div
                                                    key={bannerIndex}
                                                    disabled={!hasItems}
                                                    onClick={() => openFeedbackModal(bannerItem['Title'])}
                                                    className={`CardGridItem`}
                                                    style={{ backgroundColor: bannerItem['BackgroundColor'], filter: hasItems ? 'none' : 'grayscale(100%) brightness(75%)', cursor: hasItems ? 'pointer' : 'none' }}
                                                >
                                                    {!hasItems && <div style={{ position: 'absolute', top: '7px', left: '15px', color: '#FFFFFF', fontSize: '8px', lineHeight: '9px', fontWeight: '500', width: '15vw', zIndex: 30, textShadow: '0px 0px 10px #000000' }}>
                                                        {Dietary && Object.keys(Dietary).filter(pref => Dietary[pref]).join(', ')} Item(s) Unavailable</div>}
                                                    {bannerItem['BackgroundImage'] &&
                                                        <>
                                                            <img
                                                                src={bannerItem['BackgroundImage']}
                                                                alt="CardGridImage"
                                                                style={{ filter: `brightness(${bannerItem['ImageBrightnessFilter']})`, zIndex: 1 }}
                                                            />
                                                            <img
                                                                src={bannerItem['BackgroundImage']}
                                                                alt="CardGridImage"
                                                            />
                                                        </>
                                                    }
                                                    <span className="BannerText" style={{ color: bannerItem['TextColor'], zIndex: 3, textShadow: `1px 1px 5px #001E3A25` }}>
                                                        {availableItemCount ?
                                                            <>
                                                                <span style={{ position: 'relative', top: '0px', left: '0px', color: '#FFFFFF', fontSize: '9px', lineHeight: '7px', fontWeight: '500', width: '15vw', textShadow: '0px 0px 10px #000000' }}>
                                                                    <i>{availableItemCount} {availableItemCount === 1 ? 'Item' : 'Items'}</i>
                                                                </span>
                                                                <br />
                                                            </> : <></>
                                                        }
                                                        {bannerItem['Title']}
                                                    </span>
                                                </div>
                                                )
                                            }
                                            )}
                                        </div>
                                    }

                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Mixed Card Grid" && (
                                        <div className={`MixedCardGridContainer`}>
                                            {item?.Layout?.sort((a, b) => (a?.Card ?? 0) - (b?.Card ?? 0)).map((bannerItem, bannerIndex) => {

                                                if (!bannerItem['Card']) return null;
                                                const key = bannerItem?.Link;

                                                let hasItems = (menuObj && (menuObj?.some(menuItem => (menuItem?.[key.split('/')[1]] === key.split('/')[key.split('/').length - 1] || menuItem?.[key?.split('/')[0]]?.includes(key?.split('/')[key?.split('/').length - 1])) && menuItem?.Price > 0 && menuItem?.Visible === true && menuItem?.Available === true)));

                                                let availableItemCount = (menuObj ?? []).filter(menuItem =>
                                                    (menuItem?.[key.split('/')[1]] === key.split('/').at(-1) ||
                                                        menuItem?.[key.split('/')[1]]?.includes?.(key.split('/').at(-1))) &&
                                                    menuItem?.Visible === true &&
                                                    menuItem?.Available === true &&
                                                    menuItem?.Price > 0).length;

                                                if (!bannerItem['Verification'] || bannerItem['Verification'] !== 'Check' || bannerItem['Verification'] === "Don't Check") {
                                                    hasItems = true;
                                                    availableItemCount = null;
                                                }

                                                return (
                                                    <div
                                                        key={bannerIndex}
                                                        disabled={!hasItems}
                                                        onClick={() => hasItems ? (bannerItem['Link'] && redirectTrigger(`${bannerItem['Link']}`)) : null}
                                                        className={`MixedCardGridItem ${bannerItem['Width']} ${bannerItem['Height']}`}
                                                        style={{ backgroundColor: bannerItem['BackgroundColor'], filter: hasItems ? 'none' : 'grayscale(100%) brightness(75%)', cursor: hasItems ? 'pointer' : 'none' }}>

                                                        {!hasItems && <div style={{ position: 'absolute', top: '7px', left: '15px', color: '#FFFFFF', fontSize: '8px', lineHeight: '9px', fontWeight: '500', width: '15vw', zIndex: 30, textShadow: '0px 0px 10px #000000' }}>
                                                            {Dietary && Object.keys(Dietary).filter(pref => Dietary[pref]).join(', ')} Item(s) Unavailable</div>}
                                                        {bannerItem['BackgroundImage'] && (
                                                            <>
                                                                <img src={bannerItem['BackgroundImage']} alt="MixedCardGridImage" style={{ filter: `brightness(${bannerItem['ImageBrightnessFilter']})`, zIndex: 1 }} />
                                                                <img src={bannerItem['BackgroundImage']} alt="MixedCardGridImageBackground" className="blur-effect-if-needed" />
                                                            </>
                                                        )}
                                                        <span className="BannerText" style={{ color: bannerItem['TextColor'], zIndex: 3, textShadow: `1px 1px 5px #001E3A25` }}>
                                                            {availableItemCount ?
                                                                <>
                                                                    <span style={{ position: 'relative', top: '0px', left: '0px', color: '#FFFFFF', fontSize: '9px', lineHeight: '7px', fontWeight: '500', width: '15vw', textShadow: '0px 0px 10px #000000' }}>
                                                                        <i>{availableItemCount} {availableItemCount === 1 ? 'Item' : 'Items'}</i>
                                                                    </span>
                                                                    <br />
                                                                </> : <></>
                                                            }
                                                            {bannerItem['Title']}
                                                        </span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                    }

                                    {item?.['Status'] === "Enable" && item?.['Type'] === "Card Slider" &&
                                        <MusicRecommendation restaurantID={restaurantID} />
                                        // <div className={`CardSliderContainer`}>
                                        //     {item?.Layout?.sort((a, b) => (a?.Card ?? 0) - (b?.Card ?? 0)).map((bannerItem, bannerIndex) => {

                                        //         if (!bannerItem['Card']) return null;
                                        //         const key = bannerItem?.Link;

                                        //         let hasItems = (menuObj && (menuObj?.some(menuItem => (menuItem?.[key.split('/')[1]] === key.split('/')[key.split('/').length - 1] || menuItem?.[key?.split('/')[0]]?.includes(key?.split('/')[key?.split('/').length - 1])) && menuItem?.Price > 0 && menuItem?.Visible === true && menuItem?.Available === true)));

                                        //         let availableItemCount = (menuObj ?? []).filter(menuItem =>
                                        //             (menuItem?.[key.split('/')[1]] === key.split('/').at(-1) ||
                                        //                 menuItem?.[key.split('/')[1]]?.includes?.(key.split('/').at(-1))) &&
                                        //             menuItem?.Visible === true &&
                                        //             menuItem?.Available === true &&
                                        //             menuItem?.Price > 0).length;

                                        //         if (!bannerItem['Verification'] || bannerItem['Verification'] !== 'Check' || bannerItem['Verification'] === "Don't Check") {
                                        //             hasItems = true;
                                        //             availableItemCount = null;
                                        //         }

                                        //         return (<div
                                        //             key={bannerIndex}
                                        //             disabled={!hasItems}
                                        //             onClick={() => hasItems ? (bannerItem['Link'] && redirectTrigger(`${bannerItem['Link']}`)) : null}
                                        //             className={`CardSliderItem`}
                                        //             style={{ backgroundColor: bannerItem['BackgroundColor'], filter: hasItems ? 'none' : 'grayscale(100%) brightness(75%)', cursor: hasItems ? 'pointer' : 'none' }}
                                        //         >
                                        //             {!hasItems && <div style={{ position: 'absolute', bottom: '7px', left: '15px', color: '#FFFFFF', fontSize: '8px', lineHeight: '9px', fontWeight: '500', width: '15vw', zIndex: 400, textShadow: '0px 0px 10px #000000' }}>
                                        //                 {Dietary && Object.keys(Dietary).filter(pref => Dietary[pref]).join(', ')} Item(s) Unavailable</div>
                                        //             }
                                        //             {bannerItem['BackgroundImage'] &&
                                        //                 <>
                                        //                     <img
                                        //                         src={bannerItem['BackgroundImage']}
                                        //                         alt="MixedCardGridImage"
                                        //                         style={{ filter: `brightness(${bannerItem['ImageBrightnessFilter']})`, zIndex: 1 }}
                                        //                     />
                                        //                     <img
                                        //                         src={bannerItem['BackgroundImage']}
                                        //                         alt="MixedCardGridImage"
                                        //                     />
                                        //                 </>
                                        //             }
                                        //             <span className="BannerText" style={{ color: bannerItem['TextColor'], zIndex: 3, textShadow: `1px 1px 5px #001E3A25` }}>
                                        //                 {availableItemCount ?
                                        //                     <>
                                        //                         <span style={{ position: 'relative', top: '0px', left: '0px', color: '#FFFFFF', fontSize: '9px', lineHeight: '7px', fontWeight: '500', width: '15vw', textShadow: '0px 0px 10px #000000' }}>
                                        //                             <i>{availableItemCount} {availableItemCount === 1 ? 'Item' : 'Items'}</i>
                                        //                         </span>
                                        //                         <br />
                                        //                     </> : <></>
                                        //                 }
                                        //                 {bannerItem['Title']}
                                        //             </span>
                                        //         </div>
                                        //         )
                                        //     })
                                        //     }
                                        // </div>
                                    }
                                    {item?.['Status'] === "Enable" && item?.['Type'] === "List Card Slider" &&
                                        <MenuDrops restaurantID={restaurantID} menuObj={menuObj} LabelsData={Labels} DietaryFilters={DietaryFilters} Dietary={Dietary} setDietary={setDietary} AddOns={AddOns} Ordering={Ordering} Messages={Messages} NavigationSuggestions={NavigationSuggestions} cart={cart} setCart={setCart} />
                                        // <div className={`ListCardSliderContainer`}>
                                        //     {item.Layout.map((item) => (item.Title &&
                                        //         <div key={item.Title} className={`ListCardSliderCard ${ListCardSliderExpanded ? 'ListCardSliderExpanded' : ''}`} onClick={() => item?.OnClick === "Navigate to Menu List" ? redirectTrigger(`${item.Link}`) : item?.OnClick === "Expand Card" ? setListCardSliderExpanded(!ListCardSliderExpanded) : null}>
                                        //             <div className="ListCardSliderCardContent">
                                        //                 <div className="ListCardSliderCardTitle"><i>{item.Title}</i></div>
                                        //                 <div className="ListCardSliderCardDescription">
                                        //                     <i>{item.CardDescription}</i>
                                        //                 </div>
                                        //                 {ListCardSliderExpanded ?
                                        //                     <>{Data?.filter((dataItem) => dataItem?.[item.Link.split('/')[1]]?.includes(item.Link.split('/')[item.Link.split('/').length - 1])).slice(0, 7).map((dataItem) => dataItem?.Visible && dataItem?.Image &&
                                        //                         (
                                        //                             <div key={dataItem.Name}
                                        //                                 onClick={(e) => { e.stopPropagation(); item?.OnClick === "Hybrid" && redirectTrigger(`${item.Link}?expandItem=${encodeURIComponent(dataItem.Name)}`) }}
                                        //                                 className="ListCardSliderCardContentItem">
                                        //                                 {dataItem.Image && <img className="ListCardSliderCardContentItemImg" src={dataItem.Image} alt={dataItem.Name} />}
                                        //                                 <div className="ListCardSliderCardContentItemText">
                                        //                                     <div>{dataItem.Name}</div>
                                        //                                     <div className="ListCardSliderCardContentItemPrice">
                                        //                                         {item.ShowItemLables && <div className="item-labels-icons">
                                        //                                             {Labels?.filter(LabelsDataItem =>
                                        //                                                 dataItem.Labels?.includes(LabelsDataItem?.['Label'])
                                        //                                             ).map(filteredLabel => (
                                        //                                                 <img
                                        //                                                     key={filteredLabel.Label}
                                        //                                                     src={filteredLabel.URL}
                                        //                                                     alt={filteredLabel.Label || 'label-icon'}
                                        //                                                     className="item-labels-icon"
                                        //                                                 />
                                        //                                             ))}
                                        //                                             {dataItem?.['KiloCalories'] && <><img src={cals} alt='cals' className="labels-icon" /><div style={{ height: '20px', fontSize: '11px', fontWeight: 600, paddingTop: '3px', color: '#B9955F' }}>{dataItem?.['KiloCalories']}</div></>}
                                        //                                             {dataItem?.['Custom Text Label'] && dataItem?.['Custom Text Label'][0] && dataItem['Custom Text Label'].map((labeltext) => (<span key={labeltext} className='item-labels-text-custom'>{labeltext}</span>))}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Best Seller</span>}
                                        //                                             {dataItem['IsNew'] && <span className='item-labels-text'>New</span>}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Popular</span>}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Recommended</span>}
                                        //                                         </div>}
                                        //                                         {item.ShowItemDescription && dataItem.Description && <>
                                        //                                             {dataItem.Description}
                                        //                                         </>}
                                        //                                         <br />
                                        //                                         {item.ShowItemPrices && dataItem.Price && <>
                                        //                                             {Object.entries(dataItem.Price).map(([size, price]) => (
                                        //                                                 <div key={size}>
                                        //                                                     {size} Rs. {price}
                                        //                                                 </div>
                                        //                                             ))}
                                        //                                         </>}
                                        //                                     </div>
                                        //                                 </div>
                                        //                             </div>
                                        //                         )
                                        //                     )}</>
                                        //                     : <>{Data?.filter((dataItem) => dataItem?.[item.Link.split('/')[1]]?.includes(item.Link.split('/')[item.Link.split('/').length - 1])).slice(0, 3).map((dataItem) => dataItem?.Visible && dataItem?.Image &&
                                        //                         (
                                        //                             <div key={dataItem.Name}
                                        //                                 onClick={(e) => { e.stopPropagation(); item?.OnClick === "Hybrid" && redirectTrigger(`${item.Link}?expandItem=${encodeURIComponent(dataItem.Name)}`) }}
                                        //                                 className="ListCardSliderCardContentItem">
                                        //                                 {dataItem.Image && <img className="ListCardSliderCardContentItemImg" src={dataItem.Image} alt={dataItem.Name} />}
                                        //                                 <div className="ListCardSliderCardContentItemText">
                                        //                                     <div>{dataItem.Name}</div>
                                        //                                     <div className="ListCardSliderCardContentItemPrice">
                                        //                                         {item.ShowItemLables && <div className="item-labels-icons">
                                        //                                             {Labels?.filter(LabelsDataItem =>
                                        //                                                 dataItem.Labels?.includes(LabelsDataItem?.['Label'])
                                        //                                             ).map(filteredLabel => (
                                        //                                                 <img
                                        //                                                     key={filteredLabel.Label}
                                        //                                                     src={filteredLabel.URL}
                                        //                                                     alt={filteredLabel.Label || 'label-icon'}
                                        //                                                     className="item-labels-icon"
                                        //                                                 />
                                        //                                             ))}
                                        //                                             {dataItem?.['KiloCalories'] && <><img src={cals} alt='cals' className="labels-icon" /><div style={{ height: '20px', fontSize: '11px', fontWeight: 600, paddingTop: '3px', color: '#B9955F' }}>{dataItem?.['KiloCalories']}</div></>}
                                        //                                             {dataItem?.['Custom Text Label'] && dataItem?.['Custom Text Label'][0] && dataItem['Custom Text Label'].map((labeltext) => (<span key={labeltext} className='item-labels-text-custom'>{labeltext}</span>))}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Best Seller</span>}
                                        //                                             {dataItem['IsNew'] && <span className='item-labels-text'>New</span>}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Popular</span>}
                                        //                                             {dataItem['IsBestSeller'] && <span className='item-labels-text'>Recommended</span>}
                                        //                                         </div>}
                                        //                                         {item.ShowItemDescription && <>
                                        //                                             {dataItem['Description'].length > 50 ? `${dataItem.Description.slice(0, 50)}...` : dataItem.Description}
                                        //                                             {dataItem['Description'].length > 50 && (
                                        //                                                 <span className="read-more">(Read more)</span>
                                        //                                             )}
                                        //                                         </>}
                                        //                                         <br />
                                        //                                         {item.ShowItemPrices && <>
                                        //                                             {Object.entries(dataItem.Price).map(([size, price]) => (
                                        //                                                 <div key={size}>
                                        //                                                     {size} Rs. {price}
                                        //                                                 </div>
                                        //                                             ))}
                                        //                                         </>}

                                        //                                     </div>
                                        //                                 </div>
                                        //                             </div>
                                        //                         )
                                        //                     )}</>
                                        //                 }
                                        //             </div>
                                        //             <div className="ListCardSliderCardContentItemViewMore" onClick={() => setListCardSliderExpanded(!ListCardSliderExpanded)}>View {ListCardSliderExpanded ? 'Less' : 'More'}</div>
                                        //         </div>
                                        //     ))}
                                        // </div>
                                    }
                                    {
                                        item?.['Status'] === "Enable" &&
                                        item?.['Type'] === "Card Carousel" &&
                                        // <CardCarousel item={item} redirectTrigger={redirectTrigger} menuObj={menuObj} Dietary={Dietary} />
                                        <BookRecommendation restaurantID={restaurantID} />
                                    }
                                    {
                                        item?.['Status'] === "Enable" &&
                                        item?.['Type'] === "Custome Cards" &&
                                        <CustomLayoutEmbed layoutData={item} />
                                    }
                                </div >
                            }
                        </div>
                    )
                })}
                {Layout?.[Layout?.findIndex(item => item.Type === "Spotify")]?.['Status'] === "Enable" && Layout?.[Layout?.findIndex(item => item.Type === "Spotify")]?.['Type'] === "Spotify" &&
                    <Playlist restaurantID={restaurantID} EmbeddingURL={Layout?.[Layout?.findIndex(item => item.Type === "Spotify")]?.['EmbeddingURL']} MusicRecommendationForm={Layout?.[Layout?.findIndex(item => item.Type === "Spotify")]?.['MusicRecommendationForm']} />
                }
            </div>
            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)}
                className="customModal"
                overlayClassName="customOverlay"
            >
                <div>
                    <h2 style={{ color: '#001E3A', fontSize: '32px', fontWeight: '800', margin: '5px 0px 10px 0px' }}>{activeDomain}&nbsp;<svg onClick={() => setShowModal(false)} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#001E3A"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg></h2>
                    <hr />
                    {QUESTION_BANK[activeDomain]?.map((item, index) => (
                        <div key={index} className="questionBlock">
                            <label style={{ color: '#001E3A', fontWeight: '600', margin: '5px 0px 10px 0px' }}>{item.q}</label>

                            {item.type === "text" ? (
                                <textarea
                                    value={answers[index]?.answer || ""}
                                    onChange={(e) => handleTextChange(index, e.target.value)}
                                />
                            ) : (
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleImageChange(index, e.target.files[0])}
                                />
                            )}
                        </div>
                    ))}

                    <button onClick={handleSubmit}>Submit</button>
                </div>
            </Modal>
            <Modal
                isOpen={abModal}
                onRequestClose={() => setAbModal(false)}
                className="customModal"
                overlayClassName="customOverlay"
            >
                <h2 style={{ color: '#001E3A', fontSize: '32px', fontWeight: '800', margin: '5px 0px 10px 0px' }}>Quick Feedback&nbsp;<svg onClick={() => setAbModal(false)} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#001E3A"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg></h2>
                <hr />
                {/* Home Layout */}
                <div>
                    <p style={{ color: '#001E3A', fontWeight: '600', margin: '10px 0px 0px 0px' }}>Home page layout</p>
                    {["A", "B"].map(opt => (
                        <label key={opt} style={{ color: '#001E3A', fontWeight: '600', margin: '0px 0px 10px 0px' }}>
                            <input
                                type="radio"
                                name="homeLayout"
                                checked={abFeedback?.homeLayout === opt}
                                onChange={() => updateABFeedback({ homeLayout: opt })}
                            />
                            {opt}
                        </label>
                    ))}
                </div>

                {/* Category Cards */}
                <div>
                    <p style={{ color: '#001E3A', fontWeight: '600', margin: '10px 0px 0px 0px' }}>Category Cards</p>
                    {["A", "B"].map(opt => (
                        <label key={opt} style={{ color: '#001E3A', fontWeight: '600', margin: '0px 0px 10px 0px' }}>
                            <input
                                type="radio"
                                name="categoryCards"
                                checked={abFeedback?.categoryCards === opt}
                                onChange={() => updateABFeedback({ categoryCards: opt })}
                            />
                            {opt}
                        </label>
                    ))}
                </div>

                {/* Need Help Cards */}
                <div>
                    <p style={{ color: '#001E3A', fontWeight: '600', margin: '10px 0px 0px 0px' }}>Need Help Cards</p>
                    {["A", "B"].map(opt => (
                        <label key={opt} style={{ color: '#001E3A', fontWeight: '600', margin: '0px 0px 10px 0px' }}>
                            <input
                                type="radio"
                                name="helpCards"
                                checked={abFeedback?.helpCards === opt}
                                onChange={() => updateABFeedback({ helpCards: opt })}
                            />
                            {opt}
                        </label>
                    ))}
                </div>

                {/* Item List Layout */}
                <div>
                    <p style={{ color: '#001E3A', fontWeight: '600', margin: '10px 0px 0px 0px' }}>Items List Layout</p>
                    {["A", "B"].map(opt => (
                        <label key={opt} style={{ color: '#001E3A', fontWeight: '600', margin: '0px 0px 10px 0px' }}>
                            <input
                                type="radio"
                                name="itemListLayout"
                                checked={abFeedback?.itemListLayout === opt}
                                onChange={() => updateABFeedback({ itemListLayout: opt })}
                            />
                            {opt}
                        </label>
                    ))}
                </div>

                {/* Comment */}
                <div>
                    <p style={{ color: '#001E3A', fontWeight: '600', margin: '5px 0px 10px 0px' }}>Anything else?</p>
                    <textarea
                        placeholder="Tell us what worked / didn't..."
                        value={abFeedback?.comment || ""}
                        onChange={(e) =>
                            updateABFeedback({ comment: e.target.value })
                        }
                    />
                </div>

                <button onClick={submitABFeedback}>Submit</button>
            </Modal>
        </div >
    );
};

export default Home;